import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {MalmøteRessurs} from "felles/tjenester/ressurser/MalmøteRessurs";
import {MalsakskjemaKontroller} from "../malsakskjema/malsakskjema";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Tidssonevalg} from "../../../../../felles/tjenester/i18n/Tidssonevalg";
import {MalmøteTjeneste, MøtemalSkjemaModell} from "../../MalmøteTjeneste";

const css = require('./møtemalskjema.scss');

export class MøtemalskjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeMoetemalskjema', {
                bindings: {gruppeId: '<', vedLagret: '&', vedAvbryt: '&'},
                controller: MøtemalskjemaKontroller.forInjisering(),
                template: require('./møtemalskjema.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            MalmøteRessurs.regNavn,
            Tidssonevalg.regNavn,
            MalmøteTjeneste.regNavn,
            MøtemalskjemaKontroller
        ]
    }

    constructor(private $scope: IScope,
                private malmøteRes: MalmøteRessurs,
                private tidssonevalg: Tidssonevalg,
                private malmøteTjeneste: MalmøteTjeneste) {
        this.tidssone = tidssonevalg.aktivTidssoneAbbr();
        this.lyttTilSaksvarighetEndret();
    }

    gruppeId: string; //settes via bindings/$onChanges
    vedLagret: (args: { mal: l.MalmøteModell }) => void; //settes via bindings/$onChanges
    vedAvbryt: () => void; //settes via bindings/$onChanges

    moetemalModell: MøtemalSkjemaModell;
    tidssone: string;

    varighetEndret(varighet: number) {
        this.moetemalModell.beregnSluttdato();
    }

    lagre(skjema) {
        if (!skjema.$valid) return;
        this.malmøteRes.oppdater(this.moetemalModell.somSpesifikasjon()).$promise
            .then(mal => this.vedLagret({mal:mal}));
    }

    avbryt() {
        this.vedAvbryt();
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'gruppeId', gruppeId => this.init());
    }

    //hjelpemetoder

    private init() {
        this.malmøteTjeneste.møtemalSkjemaModell(this.gruppeId)
            .then(modell => this.moetemalModell = modell);
    }

    private lyttTilSaksvarighetEndret() {
        this.$scope.$on(MalsakskjemaKontroller.eventMalsaksskjemaVarighetEndret, (e, nyVarighet) => {
            this.moetemalModell.beregnSluttdato();
        });
    }
}
